export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";